export default __webpack_public_path__ + "static/media/icon-edit.4cf9efc4.svg";